<template>
    <div v-if="loader">
        <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
    </div>
    <div v-else>
        <v-data-table :headers="encabezados" :items="detalles" class="elevation-1" :search="search">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Maquinas</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details>
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-form ref = "form" lazy-validation>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                <v-icon left>
                                    mdi-plus
                                </v-icon>
                                Nuevo
                            </v-btn>
                        </template>
                        <v-card :loading="loading">
                            <template slot="progress">
                                <v-progress-linear color="primary" height="7" indeterminate></v-progress-linear>
                            </template>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field v-model="editedItem.machine" @input="editedItem.machine = editedItem.machine.toUpperCase()" label="Maquina" :rules=rules_validar>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="editedItem.code" @input="editedItem.code = editedItem.code.toUpperCase()" label="Clave" :rules=rules_validar></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-autocomplete :items="categorias" item-text="machine_category"
                                                item-value="id" v-model="editedItem.machine_category_id"
                                                label="Categoria" :rules=rules_validar>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-textarea v-model="editedItem.observations" @input="editedItem.observations = editedItem.observations.toUpperCase()" label="Observaciones">
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close" :disabled="disBoton">
                                    Cancelar
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="save" :disabled="disBoton">
                                    Guardar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    </v-form>
                    <v-dialog v-model="dialogDelete" max-width="500px" persistent>
                        <v-card :loading="loading">
                            <template slot="progress">
                                <v-progress-linear color="primary" height="7" indeterminate></v-progress-linear>
                            </template>
                            <v-card-title class="text-h5">¿Estas seguro de eliminar?</v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDelete" :disabled="disBoton">Cancelar</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm" :disabled="disBoton">OK</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon color="buttonEdit" small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon color="closeSesion" small @click="deleteItem(item)" class="mr-2">
                    mdi-delete
                </v-icon>
                <v-icon color="buttonThird" small @click="addDocument(item)">
                    mdi-clipboard-list-outline
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="consultarMaquinas">
                    Consultar
                </v-btn>
            </template>
        </v-data-table>

        
        <v-dialog v-model="dialog_documentos" width="900px" max-width="900px">
            <v-card :loading="loader_form">
                <template slot="progress">
                                <v-progress-linear color="primary" height="7" indeterminate></v-progress-linear>
                            </template>
                <v-card-title>
                    <span class="text-h6">Metodologías Asigandas</span>
                </v-card-title>
                <div v-if="loader_detail">
                    <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
                </div>
                <div v-else>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="10" md="10">
                                <v-autocomplete :items="documentos" item-text="document" item-value="id"
                                    v-model="documento_seleccionado" :error-messages="error_messages" return-object
                                    label="Metodología">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="2" md="2">
                                <v-btn class="mx-2" fab dark color="primary" @click="agregarDetalle">
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-data-table :headers="documentos_encabezados" :items="documentos_detalles"
                            class="elevation-1">
                            <template v-slot:item.actions="{ item }">
                                <v-icon small @click="deleteDetail(item)">
                                    mdi-delete
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialog_documentos = false" :disabled="disBoton">
                            Cancelar
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="saveDocumentos" :disabled="disBoton">
                            Guardar
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
        <template>
            <v-snackbar
                v-model = "alert"
                :timeout="tiempo_muestra"
                :value="true"
                :color = "color_alerta"
                absolute
                right
                rounded="pill"
            >
            <v-icon
                class="mr-3"
            >
                {{icono_alerta}}
            </v-icon>
                {{texto_alerta}}
            </v-snackbar>
        </template>
    </div>
</template>



<script>

import service from "@/core/Service.js";
export default {
    metaInfo: {
        title: 'Máquinas'
    },
    data: () => ({
        tiempo_muestra:1500,
        url_ruta:"machine",
        alert: false,
        texto_alerta:"",
        icono_alerta: "",
        color_alerta: "",
        dialog: false,
        disBoton: false,
        loading: false,
        loader: true,
        dialogDelete: false,
        loader_detail:false,
        search: "",
        loader_form:false,
        encabezados: [
            {
                text: 'Clave',
                value: 'code',
            },
            { text: 'Maquina', value: 'machine' },
            { text: 'Categoria', value: 'machine_category' },
            { text: 'Observaciones', value: 'observations' },
            { text: 'Acciones', value: 'actions', sortable: false },
        ],
        categorias: [

        ],
        error_messages:[],
        detalles: [],
        editedIndex: -1,
        editedItem: {
            code: '',
            machine: '',
            observations: '',
            machine_category_id: '',
        },
        defaultItem: {
            code: '',
            machine: '',
            observations: '',
            machine_category_id: '',
        },

        documentos:[

        ],
        documento_seleccionado:null,
        documentos_encabezados: [
            {
                text: 'Metodología',
                value: 'document',
                sortable: false
            },
            {
                text: 'Observaciones',
                value: 'observations',
                sortable: false
            },
            { text: 'Acciones', value: 'actions', sortable: false },
        ],
        documentos_detalles:[],
        dialog_documentos:false,
        rules_validar: [(v) => !!v || "Campo requerido"]
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Nueva Maquina' : 'Modificar Maquina'
        },
    },

    watch: {
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },
    },

    created() {
        this.consultarMaquinas();
        this.consultarCategoriaMaquina();
        this.consultarDocumentos();
    },

    methods: {
        consultarCategoriaMaquina() {
            this.loader = true;
            service
                .consultarDatos(this.url_ruta)
                .then((response) => {
                    this.loader = false;
                    if (response.data.response_flag == 1) {
                        this.categorias = response.data.response;
                    }
                })
                .catch(() => {
                    this.loader = false;
                    console.log("Problema al consultar las maquinas");
                });
        },

        consultarMaquinas() {
            this.loader = true;
            service
                .consultarMaquinas()
                .then((response) => {
                    this.loader = false;
                    if (response.data.response_flag == 1) {
                        this.detalles = response.data.response;
                    }
                })
                .catch(() => {
                    this.loader = false;
                    console.log("Problema al consultar las maquinas");
                });
        },

        consultarDocumentos() {
            this.loader = true;
            service
                .consultarDocumentos()
                .then((response) => {
                    this.loader = false;
                    if (response.data.response_flag == 1) {
                        this.documentos = response.data.response;
                    }
                })
                .catch(() => {
                    this.loader = false;
                    console.log("Problema al consultar los documentos");
                });
        },

        consultarDocumentosAsignados() {
            this.loader_detail = true;
            service
                .consultarDocumentosAsignados(this.editedItem.id)
                .then((response) => {
                    this.loader_detail = false;
                    if (response.data.response_flag == 1) {
                        this.documentos_detalles = response.data.response;
                    }
                })
                .catch(() => {
                    this.loader_detail = false;
                    console.log("Problema al consultar actividades");
                });
        },


        editItem(item) {
            this.editedIndex = this.detalles.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        deleteItem(item) {
            this.editedIndex = this.detalles.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm() {
            this.loading = true;
            this.disBoton = true;
            service
                .eliminarDatos(this.url_ruta, this.editedItem , this.editedItem.id)
                .then((response) => {
                    if(response.data.response_flag === 1){
                        this.consultarMaquinas();
                        this.loading = false;
                        this.disBoton = false;
                        this.closeDelete();
                        this.texto_alerta= "Se ha eliminado con éxito la máquina"
                        this.icono_alerta = "mdi-checkbox-marked-circle-outline";
                        this.color_alerta = "success";
                        this.alert = true;
                    }
                    else if(response.data.response_flag !== 1 || response.data === null){
                        this.consultarMaquinas();
                        this.loading = false;
                        this.disBoton = false;
                        this.closeDelete();
                        this.texto_alerta= "Ocurrió un error al eliminar la máquina"
                        this.icono_alerta = "mdi-close-circle";
                        this.color_alerta = "red darken-2";
                        this.alert = true;
                    }
                })
                .catch(() => {
                    console.log("Problema al consultar las maquinas");
                });
        },

        deleteDetail(item){
            this.documentos_detalles.splice(item, 1)
        },

        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
            this.$refs.form.resetValidation();
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save() {
            if(this.$refs.form.validate()){
                this.loading = true;
                this.disBoton = true;
                if (this.editedIndex > -1) {
                service
                    .modificarDatos(this.url_ruta, this.editedItem,this.editedItem.id)
                    .then((response) => {
                        if(response.data.response_flag === 1){
                            this.consultarMaquinas();
                            this.loading = false;
                            this.disBoton = false;
                            this.close();
                            this.texto_alerta= "Se ha modificado con éxito la máquina"
                            this.icono_alerta = "mdi-checkbox-marked-circle-outline";
                            this.color_alerta = "success";
                            this.alert = true;
                        }
                        else if(response.data.response_flag !== 1 || response.data === null){
                            this.consultarMaquinas();
                            this.loading = false;
                            this.disBoton = false;
                            this.close();
                            this.texto_alerta= "Ocurrió un error al modificar la máquina"
                            this.icono_alerta = "mdi-close-circle";
                            this.color_alerta = "red darken-2";
                            this.alert = true;
                        }
                    })
                    .catch(() => {
                        console.log("Problema al consultar las maquinas");
                    });
            } else {
                service
                    .ingresarDatos(this.url_ruta,this.editedItem)
                    .then((response) => {
                        if(response.data.response_flag === 1){
                            this.consultarMaquinas();
                            this.loading = false;
                            this.disBoton = false;
                            this.close();
                            this.texto_alerta= "Se ha guardado con éxito la máquina"
                            this.icono_alerta = "mdi-checkbox-marked-circle-outline";
                            this.color_alerta = "success";
                            this.alert = true;
                        }
                        else if(response.data.response_flag !== 1 || response.data === null){
                            this.consultarMaquinas();
                            this.loading = false;
                            this.disBoton = false;
                            this.close();
                            this.texto_alerta= "Ocurrió un error al guardar la máquina"
                            this.icono_alerta = "mdi-close-circle";
                            this.color_alerta = "red darken-2";
                            this.alert = true;
                        }
                    })
                    .catch(() => {
                        console.log("Problema al consultar las maquinas");
                    });
                }
            }
        },

        addDocument(item) {
            this.editedIndex = this.detalles.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog_documentos = true;
            this.consultarDocumentosAsignados();
        },

        
        agregarDetalle() {
            if (this.documento_seleccionado != null) {
                if (this.documentos_detalles.findIndex(element => element.id == this.documento_seleccionado.id) === -1) {

                    this.documentos_detalles.push(this.documento_seleccionado);
                    this.documento_seleccionado = null;
                    this.error_messages = [];
                } else {
                    this.error_messages = [];
                    this.error_messages.push("El documento seleccionado ya fue relacionado a la maquina");
                }
            } else {
                this.error_messages = [];
                this.error_messages.push("Debe seleccionar un documento para realizacionarlo a la maquina");
            }
        },

        saveDocumentos() {
            this.loader_form = true;
            this.disBoton = true;
            this.editedItem.detalles = this.documentos_detalles;
            service
                .ingresarMaquinaDocumento(this.editedItem)
                .then((response) => {
                    if(response.data.response_flag === 1){
                        this.loader_form = false;
                        this.disBoton = false;
                        this.dialog_documentos = false;
                        this.texto_alerta= "Se han guardado con éxito los documentos"
                        this.icono_alerta = "mdi-checkbox-marked-circle-outline";
                        this.color_alerta = "success";
                        this.alert = true;
                    }
                    else if(response.data.response_flag !== 1 || response.data === null){
                        this.loader_form = false;
                        this.disBoton = false;
                        this.dialog_documentos = false;
                        this.texto_alerta= "Ocurrió un error al guardar los documentos"
                        this.icono_alerta = "mdi-close-circle";
                        this.color_alerta = "red darken-2";
                        this.alert = true;
                    }
                })
                .catch(() => {
                    console.log("Problema al consultar los documentos");
                });
        },
    },
}
</script>